<script context="module" lang="ts">
  export const selectedKey = Symbol();
  export interface Select {
    selected: any[];
    allowEmpty: boolean;
  }
</script>

<script lang="ts">
  import { getContext, onDestroy, onMount, setContext } from "svelte";
  import { type Writable, writable } from "svelte/store";
  import * as _ from "lodash-es";

  export let values: string[] | object[] = [];
  export let value: string | object | undefined = undefined;
  export let maxHeight: `${number}px` = "500px";
  export let allowEmpty = false; // if false, only one value can be selected at a time

  // a writable store that is used to keep track of the selected items
  // and a boolean (allowEmpty) that determines if zero items can be selected
  // (i.e. checkbox-like behaviour vs radio-like behaviour)
  setContext(selectedKey, writable({ selected: value ? [value] : values, allowEmpty }));
  let selection = getContext<Writable<Select>>(selectedKey);

  // sync the selected items of the store with the value(s) props
  $: if (!_.isEqual(values, $selection.selected)) {
    values = $selection.selected;
    value = $selection.selected.length ? $selection.selected[0] : null;
  }

  let element: HTMLElement;
  let isSectionOverflowing: boolean;
  let observer: ResizeObserver;

  onMount(() => {
    const addBottomFade = () => {
      if (!element) return;
      // we only need to show the fade if the section is overflowing
      isSectionOverflowing = element?.scrollHeight > element?.offsetHeight;
    };
    observer = new ResizeObserver(addBottomFade);

    observer.observe(element);
  });

  onDestroy(() => {
    observer.disconnect();
  });
</script>

<div
  on:select
  bind:this={element}
  style:max-height={maxHeight}
  class:-mr-1={isSectionOverflowing}
  class="scrollbar-thin dark:scrollbar-glossy-dark scrollbar-glossy-light overflow-y-auto overscroll-contain"
>
  <slot />
</div>
